import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loanAmount: "100000",
  timePeriod: "1",
  intrestRate: "5",
  prePayment: '1000',
  newEmi: null,
  edErrors: null,
  timeUnit: "Year",
  totalAmount: 0,
  remainingPrinciple: 0,
};

const earlyLoanSlice = createSlice({
  name: "earlyLoanCalculator",
  initialState: initialState,

  reducers: {
    setLoanAmmount: (state, action) => {
      state.loanAmount = action.payload;
    },
    setTimePeriod: (state, action) => {
      state.timePeriod = action.payload;
    },
    setIntrestRate: (state, action) => {
      state.intrestRate = action.payload;
    },
    setPrePayment: (state, action) => {
      state.prePayment = action.payload;
    },
    setNewEmi: (state, action) => {
      state.newEmi = action.payload;
    },
    setTimeUnit: (state, action) => {
      state.timeUnit = action.payload;
    },
    setTotalAmount: (state, action) => {
      state.totalAmount = action.payload;
    },
    setRemainingPrinciple: (state, action) => {
      state.remainingPrinciple = action.payload;
    },
    resetEarlyData: (state) => {
      return initialState;
    },
  }
});

export const { setActiveCalculater } = earlyLoanSlice.actions;
export const { setLoanAmmount, setTimePeriod, setTimeUnit, setIntrestRate, setNewEmi, setPrePayment, resetEarlyData, setTotalAmount, setRemainingPrinciple } = earlyLoanSlice.actions;
export default earlyLoanSlice.reducer;